import { SnippetsOutlined } from '@ant-design/icons';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { createSubsectionSchema } from './createSubsectionSchema.ts';
import { type ISubsectionWidget } from './ISubsectionWidget.ts';
import { SubsectionConfigComponent } from './SubsectionConfigComponent.tsx';
import { SubsectionWidgetComponent } from './SubsectionWidgetComponent.tsx';
import { SubsectionWidgetConfigSchema } from './SubsectionWidgetConfigSchema.ts';
import { SubsectionWidgetPreview } from './SubsectionWidgetPreview.tsx';

export const SubsectionWidetType: IWidgetType<ISubsectionWidget> = {
  type: WidgetType.Subsection,
  mainType: WidgetMainType.Container,
  category: WidgetCategory.Advanced,
  name: 'Sottosezione',
  icon: <SnippetsOutlined />,
  hasValue: false,
  getReference: getSimpleWidgetReference(Datatype.Empty),
  formComponent: SubsectionWidgetComponent,
  createFormSchema: createSubsectionSchema,
  configComponent: SubsectionConfigComponent,
  configValidator: SubsectionWidgetConfigSchema,
  drawerWidth: '90%', // TODO da verificare
  previewComponent: SubsectionWidgetPreview,
  translationSchema: tran.widget({
    label: tran.rte(),
    placeholder: tran.string(),
  }),
  rules: [],
  isValidParent: parent => parent?.type !== WidgetType.Subsection,
};
